const BREhelper = (data) => {
    let value = data?.value?.value
    if (value == 0) {
        return <>{value}</>
    } else if (value == null || value == '') {
        return <>---</>  
    } else if (typeof value === "number") {
        return <>{value?.toFixed(2)?.replace('.00', '')}</>
    } else if (Array.isArray(value)) {
        if (value.every(element => {
            return typeof element === 'number';
          })) {
            return <>{value?.join(',')}</>
        }else{
        return <>{value?[...new Set(value)].join(','):''}</>
        }
    } else {
        return (
            <>{value}</>
        )
    }

}

export default BREhelper